export const ORG_PAGE_ACCESS_OPTIONS = [
  { id: "careConsole", label: "Care Console", route: "/", category: "Care Operations" },
  { id: "bulkUpload", label: "Bulk Upload", route: "/", category: "Care Operations" },
  { id: "callSettings", label: "Call Settings", route: "/", category: "Care Operations" },
  { id: "dashboard", label: "Dashboard", route: "/Dashboard", category: "Care Operations" },
  { id: "voiceOps", label: "Voice Ops", route: "/VoiceOps", category: "Care Operations" },
  { id: "dialer", label: "Dialer", route: "/dialer", category: "Care Operations" },
  { id: "support", label: "Support", route: "/support", category: "Support" },
  { id: "tickets", label: "Tickets", route: "/tickets", category: "Support" },
  {
    id: "onBoardingForm",
    label: "Prompt Hub",
    route: "/prompt-hub",
    category: "Configuration",
  },
  {
    id: "agentConfig",
    label: "Agent Config",
    route: "/agent-config",
    category: "Configuration",
  },
  {
    id: "apiIntegration",
    label: "API Integration",
    route: "/api-integration",
    category: "Configuration",
  },
  { id: "toolDefinitions", label: "Tools", route: "/tools", category: "Configuration" },
  { id: "browserSkills", label: "Browser Skills", route: "/", category: "Configuration" },
  {
    id: "agentReleases",
    label: "Agent Releases",
    route: "/agent-releases",
    category: "Configuration",
  },
  { id: "addUsers", label: "Add Users", route: "/add-users", category: "Administration" },
  {
    id: "adminDashboard",
    label: "Admin Dashboard",
    route: "/AdminDashboard",
    category: "Administration",
  },
  {
    id: "manageOrg",
    label: "Admin Center",
    route: "/admin-center",
    category: "Administration",
  },
  // Service agents: no Console page; enabling one lets that agent's service token act on the practice.
  {
    id: "onboardingAgent",
    label: "Julius (onboarding agent)",
    route: "/",
    category: "Agents",
  },
  {
    id: "maintenanceAgent",
    label: "Quintus (maintenance agent)",
    route: "/",
    category: "Agents",
  },
];

export const ORG_PAGE_ACCESS_CATEGORIES = [
  "Care Operations",
  "Support",
  "Configuration",
  "Administration",
  "Agents",
];

export const ORG_PAGE_IDS = ORG_PAGE_ACCESS_OPTIONS.map((option) => option.id);

export const ORG_PAGE_ROUTE_MAP = ORG_PAGE_ACCESS_OPTIONS.reduce(
  (result, option) => ({
    ...result,
    [option.id]: option.route,
  }),
  {},
);
